import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import store from './store/store'
import BootstrapVue from 'bootstrap-vue'
import Fragment from 'vue-fragment'
import axios from 'axios'
import VueAxios from 'vue-axios'
var testCICD = '20250414';

var testCICD = '20250311';

if (localStorage.getItem('user') && localStorage.getItem('accessToken') && localStorage.getItem('tokenType')) {
  var firstPath = window.location.pathname + window.location.search;
  store.state.user = JSON.parse(localStorage.getItem('user'));
  store.state.accessToken = JSON.parse(localStorage.getItem('accessToken'));
  store.state.tokenType = JSON.parse(localStorage.getItem('tokenType'));
  
  axios
    .get('/ccb/auth/checkLoggedIn', store.getters.authHeader)
    .then(response => {
      store.dispatch('login_success',{user:store.state.user, accessToken:store.state.accessToken, tokenType:store.state.tokenType});
      if(localStorage.getItem('menuList')){
        
        var sessionMenu = localStorage.getItem('menuList')
        store.commit('setMenuList',JSON.parse(sessionMenu));    
        store.commit('setLabelGroupList',JSON.parse(sessionMenu).submenuList);
        var langList = localStorage.getItem('langList')      
        store.commit('setLanguageList',JSON.parse(langList));
        store.state.fullModelList = JSON.parse(localStorage.getItem('fullModelList'));
        setTimeout(() => {       
          vue_app.$router.push(firstPath)
        }, 300);
      }
      else {
        router.push("/")
      }
      
    })
    .catch(error => {
      console.log(error);
      localStorage.removeItem('menuList');
      localStorage.removeItem('langList');
      localStorage.removeItem('fullModelList');
      localStorage.removeItem('currentModel');
      localStorage.removeItem('currentVetele');
      localStorage.removeItem('user');
      localStorage.removeItem('accessToken');
      localStorage.removeItem('tokenType');
      router.push("/")
    })
}

axios.interceptors.response.use((response) => {
  return response;
}, function (error) {
  let errorMessage = error
  if (error.response) {
    if (error.response.status === 401) {
      console.log('unauthorized, logging out ...');
      store.dispatch('logout');
    }
    if (error.response.data) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      errorMessage = error.response.data;
    }
  } else if (error.request) {
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js
    console.log(error.request);
  } else {
    // Something happened in setting up the request that triggered an Error
    console.log('Error', error.message);
  }
  store.commit('setSpinnerStatus',false);
  return Promise.reject(errorMessage);
});

Vue.use(Fragment.Plugin)
Vue.use(BootstrapVue)
Vue.use(VueAxios, axios)
Vue.mixin({
  methods:{
    findElementByTaxType (source,target) {
      var res = null;
      var findElement = function (el) {
          return el.taxType == target
      }
      return source.find(findElement);
    },
    findElementById (source,target) {
      var res = null;
      var findElement = function (el) {
          return el.id == target
      }
      return source.find(findElement);

    },
    findElementByValue (source,target) {
      var res = null;
      var findElement = function (el) {
          return el.value == target
      }
      return source.find(findElement);

    },
    findElementByName (source,target) {
      var res = null;
      var findElement = function (el) {
          return el.name == target
      }
      return source.find(findElement);

    },
    findElementByDescription (source,target) {
      var res = null;
      var findElement = function (el) {
          return el.description == target
      }
      return source.find(findElement);

    },
    findElementByCode (source,target) {
      var res = null;
      var findElement = function (el) {
          return el.code == target
      }
      if(this.checkSource(source))
        return source.find(findElement);
      else
        return null;
    },
    findElementByLanguageCode (source,target) {
      var res = null;
      var findElement = function (el) {
          return el.language.code == target
      }
      return source.find(findElement);

    },
    findDefaultElementByLanguageCode (source,target) {
      var res = null;
      var findElement = function (el) {
          return (el.language.code == target && el.model.modelcode == 'DEFAULT')
      }
      return source.find(findElement);

    },
    filterElementsByLanguageCode (source,target) {
      var res = null;
      var findElement = function (el) {
          return (el.language.code == target)
      }
      return source.filter(findElement);

    },
    filterElementsByLanguageCodeAndModel (source,target) {
      var res = null;
      var findElement = function (el) {
          return (el.language.code == target.language && (el.model.modelcode == target.modelcode || el.model.modelcode == 'DEFAULT'))
      }
      return source.filter(findElement);

    },
    filterElementsByLanguageCodeAndModelWidthoutDefault (source,target) {
      var res = null;
      var findElement = function (el) {
          return (el.language.code == target.language && el.model.modelcode == target.modelcode)
      }
      return source.filter(findElement);

    },
    findElementInOptByLanguageCode (source,target) {
      var res = null;
      var findElement = function (el) {
          return el.optItem.language.code == target
      }
      return source.find(findElement);

    },
    findElementByModelCode (source,target) {
      var res = null;
      var findElement = function (el) {
          return el.modelcode == target
      }
      return source.find(findElement);

    },
    findElementByModelCodeAndModelId (source,target) {
      var res = null;
      var findElement = function (el) {
          return (el.modelcode == target.modelcode && el.modelId == target.modelId)
      }
      return source.find(findElement);

    },
    filterAccessori (source) {
      var res = null;
      var findElement = function (el) {
          return (el.accessorio)
      }
      if(this.checkSource(source))
        return source.filter(findElement);
      else
        return [];
    },
     filterCustPrg (source) {
      var res = null;
      var findElement = function (el) {
          return (el.extendedWarranty)
      }
      if(this.checkSource(source))
        return source.filter(findElement);
      else
        return [];

    }, 
    filterOpt (source) {
      var res = null;
      var findElement = function (el) {
          return (!el.isFuoriserie && !el.extendedWarranty && !el.accessorio && !( el.intExtCrpt || el.accessorio || el.extendedWarranty || el.maintenancePrg))
      }
      if(this.checkSource(source))
        return source.filter(findElement);
      else
        return [];

    },
    filterFuoriserie (source) {
      var res = null;
      var findElement = function (el) {
          return (el.isFuoriserie && !el.extendedWarranty && !el.accessorio && !( el.intExtCrpt || el.accessorio || el.extendedWarranty || el.maintenancePrg))
      }
      if(this.checkSource(source))
        return source.filter(findElement);
      else
        return [];

    }, 
    removeFromArr(arr, value) {     
      return arr.filter(function(ele){ 
          return ele != value; 
      });
    },
    findElementByVetele(source,target) {
      var res = null;
      var findElement = function (el) {
          return el.vetele == target
      }
      if(this.checkSource(source))
        return source.find(findElement);
      else
        return null;

    },
    findElementByIdCountry(source,target) {
      var res = null;
      var findElement = function (el) {
          return el.idCountry == target
      }
      if(this.checkSource(source))
        return source.find(findElement);
      else
        return null;
  
    },
    findElementBySolMarket(source,target) {
      var res = null;
      var findElement = function (el) {
          return el.id.idSolMarket == target
      }
      if(this.checkSource(source))
        return source.find(findElement);
      else
        return null;
  
    },
    checkSource(source) {
      return Array.isArray(source); 
    },
    allineaMenu(ev){
       document.querySelector("#sidebar").style.transform = "translateY("+window.scrollY+"px)"
    }
  }
})

Vue.config.productionTip = false
Vue.config.devtools = true

Vue.directive('resize', {
  inserted: function(el, binding) {
    const onResizeCallback = binding.value;
    window.addEventListener('resize', () => {
      const width = el.offsetWidth;
      const height = el.offsetHeight;
      onResizeCallback(width, height);
    })
  }
});

window.vue_app = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
